// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function () {
 
    window.onload = function () {
        scrollW();
        window.addEventListener('scroll', function () {
            scrollW();
        });

    };

    // Email signup animation

    if (document.getElementById('email-signup')) {
        document.getElementById('email-signup_FNAME').addEventListener('focus', function () {
                this.parentElement.classList.add('moved');
            }
        );
        document.getElementById('email-signup_LNAME').addEventListener('focus', function () {
                this.parentElement.classList.add('moved');
            }
        );
        document.getElementById('email-signup_email_address').addEventListener('focus', function () {
                this.parentElement.classList.add('moved');
            }
        );
    }

    // CMS forms label animation
    document.addEventListener('focusin', function (e) {
        const field = e.target.closest('.form-module__field');
        const input = e.target;

        if (!field) {
            return;
        }

        if (input.tagName.toLowerCase() === 'input' && (input.type.toLowerCase() === 'checkbox' || input.type.toLowerCase() === 'radio')) {
            return;
        }
        field.classList.add('moved');
    });

    // Remove empty <p> tags created by TinyMCE

    const paragraph = document.querySelectorAll('p') || [];
        paragraph.forEach(function (e) {
        if (e.innerHTML.trim() === '') {
            e.parentNode.removeChild(e);
        }
    });


    // Form modules animation
    if (
        document.querySelector('.form-module-wrapper')
    ) {
        document.querySelectorAll('.form-module-wrapper').forEach(function (text) {
            const form = text.querySelector('.form-module');
            if (form) {
                form.classList.add('animate-fade','top');
            }
        });
    }

    // Text modules animation
    if (document.querySelector('.text-modules-wrapper')) {
        document.querySelectorAll('.text-modules-wrapper').forEach(function (text) {
            const textModule = text.querySelector('.text-modules');
            if (textModule) {
                textModule.classList.add('animate-fade','top');
            }
        });
    }

    // Global sitemap animation
    if (document.querySelector('.global-sitemap')) {
        document.querySelector('.global-sitemap').classList.add('animate-fade','top');
    }

    // Burger Menu 
	const button_menu = document.querySelectorAll('.js-open-menu')
	const menu_section = document.querySelector('aside.burger-menu')
	if(menu_section && button_menu) {
		button_menu.forEach((cta) => {
			cta.addEventListener('click', (e) => {
				e.preventDefault()
				menu_section.classList.toggle('open')
			})
		})
	}

})();

function closeBurgerMenu() {
    const menuSection = document.querySelector('aside.burger-menu');
    if (menuSection) {
        menuSection.classList.remove('open');
    }
}


function scrollW() {
    let st = window.pageYOffset || document.documentElement.scrollTop;
    const header = document.getElementById('header');

    if (!header) {
        return;
    }
    if (st > 80) {
        if (st > lastScrollTop) {
            if (!header.classList.contains('down')) {
                header.classList.add('down');
                header.classList.remove('up');
            }
        } else {
            if (!header.classList.contains('up')) {
                header.classList.add('up');
                header.classList.remove('down');
            }
        }
    } else {
        if (
            header.classList.contains('up') ||
            header.classList.contains('down')
        ) {
            header.classList.remove('up');
            header.classList.remove('down');
        }
    }
    lastScrollTop = st <= 0 ? 0 : st;
}


// Get SEO from URL
function getSeoFromUrl(pathname = location.pathname) {

    const parts = pathname.split('/').filter(Boolean);

    if (parts[0] === 'events' && parts[1]) {
        return 'events/' + parts[1];
    }

    return parts.pop() || 'home';
}


// Load page
function loadPage(seo,push = true) {

    closeBurgerMenu();

    const container = document.getElementById('content');

    if (!container) {
        console.error('content not found');
        return;
    }

    const isHome = seo === 'home';
    const currentPage = document.body.dataset.page || 'default';
    const delay = currentPage === 'home' && !isHome ? 800 : 200;
    const content = new FormData();

    content.append('operation','getPageContent');
    content.append('folder',CLIENT_FOLDER);
    content.append('seo',seo);
    container.classList.add('loading');

    setTimeout(function () {
        fetch(`${site_url}ajax/functions.php`,{
                method: 'POST',
                body: content
            }
        )

        .then(function (response) {
            if (!response.ok) {
                throw new Error(
                    'HTTP error: ' +
                    response.status
                );
            }
            return response.json();
        })

        .then(function (data) {
            container.innerHTML = data.html || '';
            updateNavigation(data.seo);
            document.body.classList.remove('home','default');

            Array.from(document.body.classList).forEach(function (className) {
                if (className.indexOf('page-') === 0) {
                    document.body.classList.remove(className);
                }
                document.body.classList.remove(className);
            });

            if (data.seo && data.seo !== 'home') {
                document.body.classList.add(data.seo);
            }
            if (data.pageId) {
                document.body.classList.add('page-' + data.pageId);
            }

            document.body.dataset.page = data.isHome ? 'home' : 'default';

            initMenus();
            initEventsSwiper();

            container.querySelectorAll('.animate-fade').forEach(function (el) {
                el.classList.add(
                    'visible',
                    'fade-in'
                );
            });

            if (data.meta && data.meta.title) {
                document.title = data.meta.title;
            }

            const metaDescription = document.querySelector('meta[name="description"]');

            if (metaDescription && data.meta && data.meta.description) {
                metaDescription.content = data.meta.description;
            }
            if (push) {
                history.pushState({ seo: seo },'', isHome ? '/' : '/' + seo);
            }

            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });

            resetPageFocus();

        })
        .catch(function (error) {
            console.error('Error loading page:',error);
        })
        .finally(function () {
            container.classList.remove('loading');
        });
    }, delay);
}

function loadEventPage(seo, push = true) {

    const container = document.getElementById('content');

    if (!container) {
        console.error('content not found');
        return;
    }

    const seoName = seo.replace(/^events\//, '');
    const content = new FormData();

    content.append('operation', 'getEventContent');
    content.append('folder', CLIENT_FOLDER);
    content.append('seo_name', seoName);

    container.classList.add('loading');

    fetch(`${site_url}ajax/functions.php`, {
        method: 'POST',
        body: content
    })
    .then(function (response) {
        if (!response.ok) {
            throw new Error('HTTP error: ' + response.status);
        }
        return response.json();
    })
    .then(function (data) {

        container.innerHTML = data.html || '';
        updateNavigation(data.seo);
        document.body.classList.remove('home', 'default');

        Array.from(document.body.classList).forEach(function (className) {
            if (className.indexOf('page-') === 0) {
                document.body.classList.remove(className);
            }
        });

        if (data.seo) {
            document.body.classList.add(data.seo);
        }

        document.body.dataset.page = 'default';

        container.querySelectorAll('.animate-fade').forEach(function (el) {
            el.classList.add('visible', 'fade-in');
        });

        if (data.meta && data.meta.title) {
            document.title = data.meta.title;
        }

        const metaDescription = document.querySelector('meta[name="description"]');

        if (metaDescription && data.meta && data.meta.description) {
            metaDescription.content = data.meta.description;
        }

        if (push) {
            history.pushState({ seo: seo },'','/' + seo);
        }

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

    })
    .catch(function (error) {
        console.error('Error loading event:', error);
    })
    .finally(function () {
        container.classList.remove('loading');
    });
}


function initNavigation() {
    document.addEventListener('click', function (e) {

        const link = e.target.closest('a');
        if (!link) return;

        if (link.getAttribute('href') === '#'  || link.getAttribute('href') === '/privacy-policy' || link.hasAttribute('data-lbx')) {
            return;
        }

        const url = new URL(link.href, location.origin);

        if (url.origin !== location.origin) return;
        if (link.hasAttribute('download')) return;
        if (url.protocol === 'mailto:' || url.protocol === 'tel:') {
            return;
        }

        e.preventDefault();
        const seo = getSeoFromUrl(url.pathname);

        // Validation events
        if (seo.indexOf('events/') === 0) {
            loadEventPage(seo);
            return;
        }
        // Validation sitemap
        if (seo === 'sitemap') {
            window.location.href = url.href;
            return;
        }

        loadPage(seo);
    });

    //  History navigation
    window.addEventListener('popstate', function () {
        const seo = getSeoFromUrl();

        // Validation events
        if (seo.indexOf('events/') === 0) {
            loadEventPage(seo, false);
            return;
        }

        loadPage(seo, false);
    });
}


// Menu
function initMenus() {
    const content = document.getElementById('content');
    const menuBlocks = content.querySelectorAll('.menus-block');

    menuBlocks.forEach(function (menuBlock) {
        const menuContainer =menuBlock.querySelector('[data-menuscontent]');
        const menuTabs =menuBlock.querySelectorAll('.menus-block__filter button');
        const menusSelect =menuBlock.querySelector('[data-menus-select]');

        if (menuTabs.length > 0) {
            menuTabs.forEach( function (tab) {
                tab.addEventListener('click', function () {
                    menuTabs.forEach(
                        function (el) {
                            el.classList.remove('active');
                        }
                    );
                    this.classList.add('active');
                    loadMenus(this.dataset.menu);
                });
            });
            menuTabs[0].click();
        }


        if (menusSelect) {
            loadMenus(menusSelect.value);
            menusSelect.addEventListener('change',function () {
                loadMenus(this.value);
            });
        }

        function loadMenus(id) {
            menuContainer.classList.add('loading');
            const url = `${site_url}ajax/functions.php` + `?operation=getMenus` + `&menu_id=${encodeURIComponent(id)}`;
            fetch(url,{method: 'GET'}).then(function (response) {
                if (!response.ok) {
                    throw new Error(
                        'HTTP error: ' +
                        response.status
                    );
                }
                return response.json();
            })
            .then(function (data) {
                if (!data || !data.html) {
                    return;
                }
                menuContainer.innerHTML = data.html;
                menuContainer.querySelectorAll('.animate-fade').forEach(function (el) {
                    el.classList.add('visible','fade-in');
                });
            })
            .catch(function (error) {
                console.error('Error loading menu:',error);
            })
            .finally(function () {
                menuContainer.classList.remove('loading');
            });
        }
    });
}

function updateNavigation(seo) {

    const navigations = document.querySelectorAll('.privary-navigation, .tertiary-navigation');

    navigations.forEach(function (navigation) {
        navigation.querySelectorAll('a').forEach(function (link) {
            link.classList.remove('active');
            const url = new URL(link.href, location.origin);
            const linkSeo = getSeoFromUrl(url.pathname);
            if (linkSeo === seo) {
                link.classList.add('active');
            }
        });
    });
}

function duplicateSlides(slider) {

    if (!slider) { return; }

    const wrapper = slider.querySelector('.swiper-wrapper');
    if (!wrapper) { return; }

    const slides = Array.from(
        wrapper.querySelectorAll('.swiper-slide')
    );

    const originalCount = slides.length;
    if (originalCount !== 3) {
        return;
    }
    let items = slides.slice();
    while (items.length < 6) {
        items = items.concat(slides);
    }
    wrapper.innerHTML = '';

    items.forEach(function (slide) {
        wrapper.appendChild(
            slide.cloneNode(true)
        );
    });
}

function resetPageFocus() {
    const startContent = document.getElementById('start-content');

    if (!startContent) {
        return;
    }

    startContent.setAttribute('tabindex', '-1');
    startContent.focus({ preventScroll: true });

    requestAnimationFrame(function () {
        startContent.removeAttribute('tabindex');
    });
}

function initEventsSwiper() {

    const eventsSlider = document.querySelector('.events-block__content');
    const venuesSlider = document.querySelector('.venues-block__content');

    if (eventsSlider && !eventsSlider.swiper) {
        duplicateSlides(eventsSlider);

        new Swiper(eventsSlider, {
            loop: true,
            speed: 700,
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            spaceBetween: 40,
            autoplay: false,
            navigation: {
                prevEl: '.events-block-prev',
                nextEl: '.events-block-next'
            },
            breakpoints: {
                630: {
                    slidesPerView: 2,
                    spaceBetween: 0
                },
                1024: {
                    slidesPerView: 'auto',
                    spaceBetween: 40
                },
                1624: {
                    slidesPerView: 'auto',
                    spaceBetween: 40
                }
            }
        });
    }

    if (venuesSlider && !venuesSlider.swiper) {
        const venuesWrapper = venuesSlider.querySelector('.swiper-wrapper');

        if (!venuesWrapper) {
            return;
        }

        duplicateSlides(venuesSlider);

        const venuesPrev = venuesSlider.querySelector('.venues-block-prev');
        const venuesNext = venuesSlider.querySelector('.venues-block-next');

        new Swiper(venuesSlider, {
            loop: true,
            speed: 700,
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            spaceBetween: 40,
            autoplay: false,
            navigation: {
                prevEl: '.venues-block-prev',
                nextEl: '.venues-block-next'
            },
            breakpoints: {
                630: {
                    slidesPerView: 2,
                    spaceBetween: 0
                },
                1024: {
                    slidesPerView: 'auto',
                    spaceBetween: 40
                },
                1624: {
                    slidesPerView: 'auto',
                    spaceBetween: 40
                }
            }
        });
    }
}

// Initial load
document.addEventListener('DOMContentLoaded', function () {
    initNavigation();
    initMenus();
    initEventsSwiper();
});